import axios from "axios";

export const AxiosFirst = axios.create({
  baseURL: "https://api.cfgold.in/api/organization/",
  withCredentials: true,
});
const Axios = axios.create({
  baseURL: "https://api.cfgold.in/api/organization/",
  withCredentials: true,
});

// export const AxiosFirst = axios.create({
//   baseURL: "https://uat.cfgold.in/api/organization/",
//   withCredentials: true,
// });
// const Axios = axios.create({
//   baseURL: "https://uat.cfgold.in/api/organization/",
//   withCredentials: true,
// });

// export const AxiosFirst = axios.create({
//   baseURL: "https://development.cfgold.in/api/organization/",
//   withCredentials: true,
// });
// const Axios = axios.create({
//   baseURL: "https://development.cfgold.in/api/organization/",
//   withCredentials: true,
// });

let isRefreshing = false;
let failedQueue = [];
 
const processQueue = (error) => {
  failedQueue.forEach((prom) => { 
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  failedQueue = [];
};

Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        // 👉 Queue में डाल दो
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => Axios(originalRequest))
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        await AxiosFirst.post("refresh-token/");

        processQueue(null);
        return Axios(originalRequest);

      } catch (err) {
        processQueue(err);
        window.location.href = "/";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default Axios;